// Code de seance : identifiant ephemere qui sert a la fois de code DICTE au
// patient (souvent age), de cle de room socket et de cle de lecture du dossier
// (getPatientByCode).
//
// CHIFFRES UNIQUEMENT, 6 chiffres. Pas de lettres ni de melange chiffre/lettre :
// le code est dit a l'oral puis tape a la main, et le public est age
// (confusions auditives b/p/t/d, m/n, f/s ; charge cognitive du melange). La
// simplicite d'usage prime.
//
// Genere par le CSPRNG du navigateur (qualite du hasard), pas Math.random().
// 10^6 = 1 000 000 valeurs, soit 100x l'ancien code a 4 chiffres : combine au
// rate-limit cote API (cf. graphql-server/src/utils/rateLimiter.js) et au
// caractere ephemere du code, l'enumeration devient impraticable. Le rempart de
// fond reste le futur token de session (cf. Docs/15).
const CODE_LENGTH = 6;

export const generateSessionCode = () => {
  const values = new Uint32Array(CODE_LENGTH);
  window.crypto.getRandomValues(values);
  let out = '';
  for (let i = 0; i < CODE_LENGTH; i += 1) {
    out += (values[i] % 10).toString(); // biais de modulo negligeable (2^32 % 10)
  }
  return out; // string, avec zeros de tete eventuels (ex. "004521")
};
